import mixpanelLib, {
  Mixpanel as MixpanelType,
  Config,
} from 'mixpanel-browser';

const mixpanelId = import.meta.env.VITE_MIXPANEL_ID as string;
const environment: string = (import.meta.env.VITE_ENV as string) || '';
const mixpanelEnabled = import.meta.env.VITE_MIXPANEL_ENABLE;

let mixpanel: MixpanelType;

if (mixpanelId && mixpanelEnabled) {
  let config: Partial<Config> = {
    record_sessions_percent: 0,
  };
  if (['dev', 'develop'].includes(environment)) {
    config = {
      ...config,
      debug: true,
      ignore_dnt: true,
    };
  }
  mixpanel = mixpanelLib.init(mixpanelId, config, 'Augintel-UI');
} else {
  console.error('Mixpanel failed to initialize');
  // The raw uninitialized lib throws on any call (e.g. track); fall back to a
  // no-op stub so a disabled/misconfigured Mixpanel never breaks the app.
  const noopStub: MixpanelType = new Proxy(() => noopStub, {
    get: () => noopStub,
    apply: () => noopStub,
  }) as unknown as MixpanelType;
  mixpanel = noopStub;
}

const Mixpanel = mixpanel;
export default Mixpanel;
